import moment from 'moment'

moment.locale('es')

const periodToDays = {
  today: 0,
  yesterday: 1,
  lastWeek: 6,
  lastMonth: 29,
  lastYear: 365,
}

export function getStartDate(period) {
  return moment().subtract(periodToDays[period], 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
}

export function getEndDate(period) {
  let endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')

  // TODO
  if (period === 'yesterday') {
    endDate = yesterday(period)
  }

  return endDate
}

function yesterday(period) {
  return moment().subtract(periodToDays[period], 'day').endOf('day').format('YYYY-MM-DD HH:mm:ss')
}

export function stringToDateObject(date) {
  return moment(date).toDate()
}

export function dateObjectToString(timeString) {
  return moment(timeString).format('YYYY-MM-DD HH:mm:ss')
}

export function timeToHourAndSeconds(time) {
  return moment(time).format('HH:mm')
}

export function isNewDay(curr, pre) {
  return moment(curr).diff(moment(pre), 'days') !== 0
}

/**
 * Now.
 *
 * @param format
 */
export function now(format) {
  return moment().format(format)
}

/**
 * String to format.
 *
 * @param {string} date
 * @param {string} format
 * @return {string}
 */
export function stringToFormat(date, format) {
  return moment(date).format(format)
}

/**
 * Is a valid date.
 *
 * @param {string} date
 * @param {string} format
 * @return {bool}
 */
export function isValidDate(date, format) {
  return moment(date, format).isValid()
}

export function ageFromBirthDate(birthDate) {
  if (!birthDate) return 'Desconocido'
  return moment().diff(moment(birthDate, 'DD/MM/YYYY'), 'years')
}

export function fromNow(date) {
  return moment(date).fromNow()
}

export function diffBetweenDates(startDate, endDate) {
  return moment(endDate).diff(startDate, 'days')
}

export function timeFromMinutes(mins, twentyFour) {
  let hours = (mins / 60) | 0
  let minutes = mins % 60 | 0

  if (twentyFour) {
    return moment().hours(hours).minutes(minutes).format('kk:mm')
  }

  return moment().hours(hours).minutes(minutes).format('HH:mm')
}

export function minutesFromTime(time) {
  return moment.duration(time).asMinutes()
}

export function timezoneOffset() {
  return moment().utcOffset()
}

/**
 * Add timezoneOffset.
 *
 * @param  {string} dateString
 * @return {string}
 */
export function addTimezoneOffset(dateString) {
  return stringToDateObject(dateString)
}

/**
 * Get that format "HH:mm" - "HH:mm"
 *
 * @param startDate
 * @param endDate
 * @return {string}
 */
export function twoMinutesToString(startDate, endDate) {
  let startDateHours = (startDate / 60) | 0
  let startDateMinutes = startDate % 60 | 0
  let endDateHours = (endDate / 60) | 0
  let endDateMinutes = endDate % 60 | 0

  let startDateString = moment().hours(startDateHours).minutes(startDateMinutes).format('HH:mm')
  let endDateString = moment().hours(endDateHours).minutes(endDateMinutes).format('HH:mm')

  return startDateString + '-' + endDateString
}
export const getNumDay = (date) => moment(date).format('D')
export const getDate = (date) => moment(date).format('MM-DD-YYYY')
